import { useEffect, useRef, useState } from "react";
import "../../../styles/panel/user/ChatWidget.css";
import moment from "jalali-moment";
import {
  getChatMyStores,
  getChatMessage,
  sendChatMessage,
} from "../../../api/chat";
import { API_BASE_URL } from "../../../api/http";
import useChatOnlineSocket from "../../../hooks/useChatOnlineSocket";
import useChatOnlineListSocket from "../../../hooks/useChatOnlineListSocket";

// آیکن‌های SVG به صورت کامپوننت کوچک — مستقل از بقیه‌ی صفحات چون این ویجت
// باید همه‌جای پنل، بدون وابستگی به صفحه‌ی فعلی، قابل‌رندر باشد
const Icon = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const CHAT_ICON = (
  <>
    <path d="M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22C17.5228 22 22 17.5228 22 12C22 10.1786 21.513 8.47087 20.6622 7" />
    <path d="M8 12H8.009M11.991 12H12M15.991 12H16" />
  </>
);
const CLOSE_ICON = (
  <>
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </>
);
const BACK_ICON = <path d="M19 12H5M11 6l-6 6 6 6" />;
const SEARCH_ICON = (
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </>
);
const ATTACH_ICON = (
  <path d="M21.44 11.05l-9.19 9.19a5.5 5.5 0 01-7.78-7.78l9.19-9.19a3.5 3.5 0 014.95 4.95l-9.2 9.19a1.5 1.5 0 01-2.12-2.12l8.49-8.48" />
);

// الگوی پس‌زمینه‌ی چت — همون پترنی که در ChatPage استفاده شده تا هر دو یک شکل باشن
const CHAT_BG_PATTERN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360"><defs><g id="ic-bag"><path d="M14 20 L46 20 L50 56 L10 56 Z"/><path d="M22 20 C22 8 38 8 38 20"/></g><g id="ic-cart"><path d="M6 8 L14 8 L22 42 L48 42 L54 18 L18 18"/><circle cx="22" cy="52" r="4.5"/><circle cx="46" cy="52" r="4.5"/></g><g id="ic-shop"><path d="M6 22 L10 6 L46 6 L50 22"/><path d="M6 22 C6 28 14 28 14 22 C14 28 22 28 22 22 C22 28 30 28 30 22 C30 28 38 28 38 22 C38 28 46 28 46 22 C46 28 50 28 50 22"/><path d="M10 24 L10 50 L46 50 L46 24"/><path d="M22 50 L22 34 L34 34 L34 50"/></g><g id="ic-site"><rect x="6" y="10" width="48" height="38" rx="4"/><path d="M6 20 L54 20"/><circle cx="13" cy="15" r="1.5" fill="currentColor" stroke="none"/><circle cx="19" cy="15" r="1.5" fill="currentColor" stroke="none"/><circle cx="25" cy="15" r="1.5" fill="currentColor" stroke="none"/><path d="M14 30 L34 30 M14 38 L46 38"/></g><g id="ic-person"><circle cx="28" cy="16" r="10"/><path d="M8 52 C8 34 48 34 48 52"/></g><g id="ic-chat"><path d="M8 10 H48 A6 6 0 0 1 54 16 V38 A6 6 0 0 1 48 44 H24 L12 54 V44 H8 A6 6 0 0 1 2 38 V16 A6 6 0 0 1 8 10 Z" transform="translate(2,0)"/><circle cx="18" cy="26" r="1.6" fill="currentColor" stroke="none"/><circle cx="28" cy="26" r="1.6" fill="currentColor" stroke="none"/><circle cx="38" cy="26" r="1.6" fill="currentColor" stroke="none"/></g><g id="ic-heart"><path d="M28 50 C6 34 6 16 18 10 C24 7 28 12 28 16 C28 12 32 7 38 10 C50 16 50 34 28 50 Z"/></g><g id="ic-star"><path d="M28 6 L34 22 L51 22 L37 32 L42 49 L28 39 L14 49 L19 32 L5 22 L22 22 Z"/></g><g id="ic-tag"><path d="M8 8 L28 8 L50 30 L30 50 L8 28 Z"/><circle cx="17" cy="17" r="3"/></g><g id="ic-gift"><rect x="8" y="22" width="40" height="30" rx="3"/><path d="M8 32 L48 32"/><path d="M28 22 L28 52"/><path d="M28 22 C16 22 16 8 24 8 C30 8 30 18 28 22 C26 18 26 8 32 8 C40 8 40 22 28 22 Z"/></g><g id="ic-headset"><path d="M8 30 C8 12 48 12 48 30"/><rect x="4" y="28" width="10" height="16" rx="4"/><rect x="42" y="28" width="10" height="16" rx="4"/><path d="M47 44 V48 C47 52 43 54 38 54"/></g><g id="ic-mail"><rect x="6" y="12" width="44" height="32" rx="4"/><path d="M6 15 L28 34 L50 15"/></g><g id="ic-shield"><path d="M28 6 L48 14 V26 C48 40 38 47 28 51 C18 47 8 40 8 26 V14 Z"/><path d="M18 27 L25 34 L38 20"/></g><g id="ic-clip"><path d="M34 10 L17 27 C12 32 12 39 17 44 C22 49 29 49 34 44 L47 31 C50 28 50 23 47 20 C44 17 39 17 36 20 L23 33 C21.5 34.5 21.5 37 23 38.5 C24.5 40 27 40 28.5 38.5 L40 27"/></g><g id="ic-help"><path d="M8 10 H48 A6 6 0 0 1 54 16 V38 A6 6 0 0 1 48 44 H24 L12 54 V44 H8 A6 6 0 0 1 2 38 V16 A6 6 0 0 1 8 10 Z" transform="translate(2,0)"/><path d="M22 22 C22 16 32 16 32 22 C32 26 27 26 27 31" /><circle cx="27" cy="37" r="1.6" fill="currentColor" stroke="none"/></g><g id="tile" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" color="#522B5B" opacity="0.08"><use href="#ic-bag" transform="translate(14,10) rotate(-10) scale(0.62)"/><use href="#ic-site" transform="translate(96,4) rotate(7) scale(0.6)"/><use href="#ic-star" transform="translate(176,18) rotate(14) scale(0.5)"/><use href="#ic-mail" transform="translate(240,8) rotate(-6) scale(0.6)"/><use href="#ic-clip" transform="translate(310,20) rotate(20) scale(0.55)"/><use href="#ic-person" transform="translate(30,66) rotate(-6) scale(0.58)"/><use href="#ic-headset" transform="translate(112,62) rotate(5) scale(0.6)"/><use href="#ic-chat" transform="translate(190,70) rotate(-8) scale(0.6)"/><use href="#ic-shop" transform="translate(266,64) rotate(9) scale(0.6)"/><use href="#ic-heart" transform="translate(20,132) rotate(12) scale(0.5)"/><use href="#ic-tag" transform="translate(90,126) rotate(-14) scale(0.56)"/><use href="#ic-shield" transform="translate(160,124) rotate(6) scale(0.58)"/><use href="#ic-cart" transform="translate(236,128) rotate(-9) scale(0.58)"/><use href="#ic-gift" transform="translate(306,132) rotate(11) scale(0.55)"/><use href="#ic-help" transform="translate(50,190) rotate(-8) scale(0.56)"/><use href="#ic-site" transform="translate(140,188) rotate(9) scale(0.55)"/><use href="#ic-star" transform="translate(214,196) rotate(-13) scale(0.48)"/><use href="#ic-person" transform="translate(280,190) rotate(7) scale(0.55)"/><use href="#ic-bag" transform="translate(10,252) rotate(8) scale(0.58)"/><use href="#ic-chat" transform="translate(80,256) rotate(-11) scale(0.55)"/><use href="#ic-headset" transform="translate(158,250) rotate(6) scale(0.55)"/><use href="#ic-mail" transform="translate(232,254) rotate(-7) scale(0.55)"/><use href="#ic-heart" transform="translate(304,256) rotate(13) scale(0.48)"/><use href="#ic-shop" transform="translate(40,306) rotate(-6) scale(0.55)"/><use href="#ic-tag" transform="translate(116,312) rotate(10) scale(0.5)"/><use href="#ic-cart" transform="translate(190,308) rotate(-8) scale(0.55)"/><use href="#ic-clip" transform="translate(262,314) rotate(15) scale(0.5)"/><use href="#ic-star" transform="translate(330,306) rotate(-10) scale(0.46)"/><use href="#ic-shield" transform="translate(56,40) rotate(18) scale(0.4)"/><use href="#ic-tag" transform="translate(136,38) rotate(-16) scale(0.38)"/><use href="#ic-heart" transform="translate(210,44) rotate(10) scale(0.36)"/><use href="#ic-gift" transform="translate(276,36) rotate(-12) scale(0.4)"/><use href="#ic-cart" transform="translate(340,48) rotate(8) scale(0.36)"/><use href="#ic-mail" transform="translate(70,96) rotate(-9) scale(0.38)"/><use href="#ic-star" transform="translate(150,98) rotate(15) scale(0.34)"/><use href="#ic-shop" transform="translate(226,94) rotate(-11) scale(0.38)"/><use href="#ic-help" transform="translate(296,98) rotate(9) scale(0.36)"/><use href="#ic-bag" transform="translate(60,160) rotate(-13) scale(0.4)"/><use href="#ic-person" transform="translate(132,158) rotate(11) scale(0.36)"/><use href="#ic-chat" transform="translate(206,162) rotate(-8) scale(0.38)"/><use href="#ic-clip" transform="translate(278,160) rotate(14) scale(0.36)"/><use href="#ic-site" transform="translate(24,222) rotate(9) scale(0.38)"/><use href="#ic-headset" transform="translate(98,224) rotate(-14) scale(0.36)"/><use href="#ic-shield" transform="translate(172,220) rotate(10) scale(0.38)"/><use href="#ic-tag" transform="translate(246,226) rotate(-9) scale(0.36)"/><use href="#ic-heart" transform="translate(320,222) rotate(12) scale(0.34)"/><use href="#ic-gift" transform="translate(58,284) rotate(-10) scale(0.38)"/><use href="#ic-cart" transform="translate(130,282) rotate(13) scale(0.36)"/><use href="#ic-mail" transform="translate(202,286) rotate(-11) scale(0.36)"/><use href="#ic-star" transform="translate(272,284) rotate(9) scale(0.34)"/><use href="#ic-shop" transform="translate(342,282) rotate(-13) scale(0.36)"/></g></defs><rect width="360" height="360" fill="none"/><use href="#tile"/></svg>`;
const CHAT_BODY_STYLE = {
  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(CHAT_BG_PATTERN_SVG)}")`,
};

// حرف اول اسم برای آواتار
const initial = (name) => (name ? name.trim().charAt(0) : "?");

// پیام‌ها از بک‌اند خونده می‌شوند (getChatMessage) — دقیقاً مثل ChatPage

// ریسپانس بک‌اند برای هر پیوست فقط id، image (مسیر نسبی روی سرور) و
// uploaded_at می‌دهد و اسمی نمی‌فرستد؛ اسم فایل از خود مسیر استخراج می‌شود.

const attachmentUrl = (path) => {
  if (!path) return "";
  return /^https?:\/\//.test(path) ? path : `${API_BASE_URL}${path}`;
};
const attachmentName = (path) => path?.split("/").pop() || "";

// آیکن‌های «تیک ارسال» (تک‌تیک) و «تیک دیده‌شده» (دوتیک) برای پیام‌های خودمون
const SEEN_TICK_SINGLE = <path d="M4 12l4 4L19 6" />;
const SEEN_TICK_DOUBLE = (
  <>
    <path d="M1 12l4 4L14 7" />
    <path d="M8 12l4 4L23 5" />
  </>
);

// بک‌اند باید وضعیت خوانده‌شدن هر پیام رو برگردونه؛ چون فایل api/chat.js در
// دسترس من نبود، فرض کردم فیلد is_read (بولین) یا read_at (تاریخ خوانده‌شدن)
// روی آبجکت پیام هست. اگه بک‌اند اسم دیگه‌ای می‌فرسته (مثلاً seen/is_seen)
// کافیه همین یک خط رو با اسم واقعی فیلد جایگزین کنی. باید دقیقاً هماهنگ با
// همین منطق در ChatPage.jsx باشه.
const isMessageSeen = (message) =>
  Boolean(message?.read ?? message?.read_at ?? message?.seen);

function SeenTicks({ seen }) {
  return (
    <span
      className={`chat-widget-seen-ticks${seen ? " seen" : ""}`}
      title={seen ? "دیده شده" : "ارسال شده"}
    >
      <Icon>{seen ? SEEN_TICK_DOUBLE : SEEN_TICK_SINGLE}</Icon>
    </span>
  );
}

function formatTime(dateString) {
  if (!dateString) return "";
  return moment(dateString).locale("fa").format("HH:mm");
}
function formatDateDivider(dateString) {
  if (!dateString) return "";
  return moment(dateString).locale("fa").format("D MMMM YYYY");
}
// اگر پیام‌ها بین چند روز پخش باشند، جداکننده تاریخ بین آن‌ها نمایش داده می‌شود
function withDateDividers(messages) {
  const out = [];
  let lastDay = null;
  for (const m of messages) {
    const day = m.created_at ? moment(m.created_at).format("YYYY-MM-DD") : null;
    if (day && day !== lastDay) {
      out.push({
        type: "divider",
        key: `divider-${day}`,
        label: formatDateDivider(m.created_at),
      });
      lastDay = day;
    }
    out.push({ type: "message", key: m.id, data: m });
  }
  return out;
}

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [activeChatId, setActiveChatId] = useState(null);
  const [query, setQuery] = useState("");
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messagesByChat, setMessagesByChat] = useState({});
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [text, setText] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [sending, setSending] = useState(false);
  // مدال بزرگ‌نمایی عکس؛ اگه پیام چند عکس داشته باشه، بین همه‌شون قابل جابجاییه
  const [previewGallery, setPreviewGallery] = useState(null); // { images: [{image,name}], index }

  // ادمین فقط اجازه‌ی مشاهده‌ی چت‌ها را دارد، نه ارسال پیام
  const role = localStorage.getItem("role");

  const isAdmin = role === "admin"; // یا user?.role === "admin"// یا user?.role === "admin"

  const panelRef = useRef(null);
  const bodyRef = useRef(null);
  const fileInputRef = useRef(null);
  const isFirstScrollRef = useRef(true);

  const totalUnread = chats.reduce((sum, c) => sum + c.unread_count, 0);
  const activeChat = chats.find((c) => c.id === activeChatId) || null;
  const rows =
    activeChatId != null
      ? withDateDividers(messagesByChat[activeChatId] || [])
      : [];

  // اسکرول به آخرین پیام هر بار که وارد یک گفتگو می‌شویم یا پیام جدیدی می‌آید
  useEffect(() => {
    if (activeChatId == null || !bodyRef.current) return;
    const list = messagesByChat[activeChatId] || [];
    if (list.length === 0) return;
    bodyRef.current.scrollTo({
      top: bodyRef.current.scrollHeight,
      // بار اولی که یک گفتگو باز می‌شه، اسکرول باید آنی باشه (بدون لغزیدن
      // از اولین پیام)؛ برای پیام‌های جدید بعدی، اسکرول نرم می‌مونه.
      behavior: isFirstScrollRef.current ? "auto" : "smooth",
    });
    isFirstScrollRef.current = false;
  }, [messagesByChat, activeChatId, open]);

  // هر بار گفتگوی دیگه‌ای باز می‌شه، دوباره باید بار اول حساب بشه
  useEffect(() => {
    isFirstScrollRef.current = true;
  }, [activeChatId]);

  // لیست چت‌ها از بک‌اند — دقیقاً مثل ChatArchive، با جستجوی سمت سرور
  useEffect(() => {
    const timer = setTimeout(() => {
      loadChats(query);
    }, 400);
    return () => clearTimeout(timer);
  }, [query]);

  const queryRef = useRef(query);
  const activeChatIdRef = useRef(activeChatId);
  const refreshTimerRef = useRef(null);

  useEffect(() => {
    queryRef.current = query;
  }, [query]);

  useEffect(() => {
    activeChatIdRef.current = activeChatId;
  }, [activeChatId]);

  useEffect(() => {
    return () => clearTimeout(refreshTimerRef.current);
  }, []);

  const loadChats = async (search = "", showLoader = true) => {
    try {
      if (showLoader) setLoading(true);
      const res = await getChatMyStores({ search });
      const list = res.data.results || [];
      // گفتگویی که الان بازه یعنی خونده شده؛ رفرش لیست نباید نشان
      // خوانده‌نشده‌اش رو برگردونه.
      setChats(
        list.map((c) =>
          c.id === activeChatIdRef.current ? { ...c, unread_count: 0 } : c,
        ),
      );
    } catch (err) {
      console.log(err);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  // رفرش بی‌صدای لیست (بدون لودر) با جستجوی فعلی. اگه چند چت پشت‌سرهم
  // آپدیت بشن، فقط یک درخواست فرستاده می‌شه.
  const handleChatListUpdate = () => {
    clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => {
      loadChats(queryRef.current, false);
    }, 300);
  };

  // پیام‌های گفتگوی فعال از بک‌اند — دقیقاً مثل ChatPage
  useEffect(() => {
    if (activeChatId == null) return;
    (async () => {
      const list = await loadMessages(activeChatId);
      // بک‌اند موقع گرفتن پیام‌ها، اون‌ها رو «خوانده‌شده» علامت می‌زنه؛ به
      // سوکت خبر می‌دیم تا ChatPage و ChatArchive تعداد خوانده‌نشده‌ها رو
      // رفرش کنن — مثل ChatPage. فقط بعد از لود اولیه صدا زده می‌شه (نه
      // داخل onUpdate) تا حلقه‌ی بی‌نهایت ایجاد نشه.
      // ادمین فقط ناظره؛ باز کردن چت توسط ادمین نباید پیام‌ها رو خوانده‌شده
      // کنه، پس نه درخواست خوانده‌شدن می‌فرستیم و نه به سوکت خبر می‌دیم.
      if (list && !isAdmin) notifyUpdate();
    })();
  }, [activeChatId]);

  const loadMessages = async (chatId, showLoader = true) => {
    try {
      if (showLoader) setMessagesLoading(true);
      // ادمین چون فقط ناظره، نباید باعث خوانده‌شدن پیام‌ها بشه؛ به بک‌اند
      // می‌گیم علامت «خوانده‌شده» نزنه (markRead: false). این پارامتر باید
      // توی api/chat.js به کوئری/بادی درخواست getChatMessage اضافه بشه
      // (مثلاً ?mark_read=0) — اسم پارامتر رو با بک‌اند/فایل api/chat.js
      // چک و در صورت نیاز تطبیق بده.
      const res = await getChatMessage(chatId, { markRead: !isAdmin });
      const list = res.data?.messages || [];
      setMessagesByChat((prev) => ({
        ...prev,
        [chatId]: list,
      }));
      return list;
    } catch (err) {
      console.log(err);
      return null;
    } finally {
      if (showLoader) setMessagesLoading(false);
    }
  };

  // فقط برای چتی که الان بازه وصل می‌شیم (روم سمت بک‌اند مخصوص همون chat_id
  // است). هر بار بک‌اند بگه این چت آپدیت شده، پیام‌هاش رو بی‌صدا دوباره
  // می‌گیریم و لیست چت‌ها رو هم مثل ChatArchive از بک‌اند رفرش می‌کنیم.
  const { notifyUpdate } = useChatOnlineSocket(activeChatId, {
    onUpdate: async () => {
      await loadMessages(activeChatId, false);
      handleChatListUpdate();
    },
  });

  // برخلاف ChatUpdateListener قبلی که فقط به چت‌های از قبل شناخته‌شده وصل
  // می‌شد، این یک سوکت سراسری و همیشه‌فعاله (مستقل از chat_id) — پس چت
  // کاملاً جدیدی که هنوز توی لیست fetch‌شده نیست هم دیده می‌شه. مثل ChatArchive.
  useChatOnlineListSocket({ onUpdate: handleChatListUpdate });

  // کلیک بیرون از پنل، پاپ‌آپ را می‌بندد
  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (panelRef.current?.contains(e.target)) return;
      if (e.target.closest?.(".floating-chat-btn")) return;
      // مدال پیش‌نمایش عکس بیرون از پنل رندر می‌شود (sibling)، پس کلیک روی
      // آن (از جمله دکمه‌های عکس قبلی/بعدی) نباید کل ویجت را ببندد.
      if (e.target.closest?.(".chat-widget-preview-overlay")) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  // کلید Escape: اول از گفتگو به لیست برمی‌گرده، بعد کل پاپ‌آپ رو می‌بنده
  useEffect(() => {
    if (!open) return;
    const handleEsc = (e) => {
      if (e.key !== "Escape") return;
      if (activeChatId != null) setActiveChatId(null);
      else setOpen(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open, activeChatId]);

  // ناوبری کیبورد داخل مدال بزرگ‌نمایی عکس: Esc برای بستن، چپ/راست برای
  // جابجایی بین عکس‌های همون پیام
  useEffect(() => {
    if (!previewGallery) return;
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setPreviewGallery(null);
      } else if (e.key === "ArrowLeft") {
        showPrevImage();
      } else if (e.key === "ArrowRight") {
        showNextImage();
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [previewGallery]);

  const showPrevImage = () => {
    setPreviewGallery((prev) => {
      if (!prev) return prev;
      const count = prev.images.length;
      return { ...prev, index: (prev.index - 1 + count) % count };
    });
  };
  const showNextImage = () => {
    setPreviewGallery((prev) => {
      if (!prev) return prev;
      const count = prev.images.length;
      return { ...prev, index: (prev.index + 1) % count };
    });
  };

  // هر وقت ویجت بسته بشه (دکمه‌ی بستن، کلیک بیرون، Escape یا دکمه‌ی شناور)،
  // دوباره به لیست چت‌ها برمی‌گردیم تا دفعه‌ی بعد روی گفتگوی قبلی باز نشه.
  useEffect(() => {
    if (open) return;
    setActiveChatId(null);
    setText("");
    setAttachments((prev) => (prev.length ? [] : prev));
    setPreviewGallery(null);
  }, [open]);

  const toggleWidget = () => setOpen((v) => !v);

  const openChat = (id) => {
    setChats((prev) =>
      prev.map((c) => (c.id === id ? { ...c, unread_count: 0 } : c)),
    );
    setActiveChatId(id);
  };

  const backToList = () => {
    setActiveChatId(null);
    setText("");
    setAttachments([]);
    setPreviewGallery(null);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files ?? []).map((file, i) => ({
      id: `${Date.now()}-${i}`,
      name: file.name,
      file,
    }));
    setAttachments((prev) => [...prev, ...files]);
    e.target.value = "";
  };
  const removeAttachment = (id) =>
    setAttachments((prev) => prev.filter((a) => a.id !== id));

  const send = async () => {
    const body = text.trim();
    if (!body && attachments.length === 0) return;
    if (sending || isAdmin) return;

    // ارسال همیشه از طریق API انجام می‌شه (سوکت الان فقط سیگنال رفرشه، نه
    // کانال ارسال). بک‌اند برای فایل‌ها فیلد images رو انتظار داره، و برای
    // متن هم body
    const payload = new FormData();
    payload.append("body", body);
    attachments.forEach((a) => payload.append("images", a.file));

    try {
      setSending(true);
      await sendChatMessage(activeChatId, payload);

      // به سوکت خبر می‌دیم که این چت آپدیت شده تا ChatPage (و هر تب/دستگاه
      // دیگه‌ای که همین چت رو باز کرده) آنی پیام جدید رو بگیره.
      notifyUpdate();

      // بک‌اند فقط message_id/chat_id برمی‌گردونه نه خود پیام رو،
      // پس برای نمایش دقیق (attachment ها با URL واقعی و...) پیام‌های
      // همین گفتگو رو دوباره از سرور می‌گیریم.
      await loadMessages(activeChatId, false);
      setChats((prev) =>
        prev.map((c) =>
          c.id === activeChatId
            ? { ...c, last_message: { created_at: new Date().toISOString() } }
            : c,
        ),
      );
      setText("");
      setAttachments([]);
    } catch (err) {
      console.log(err);
    } finally {
      setSending(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <>
      <button
        type="button"
        className={`floating-chat-btn${open ? " is-open" : ""}`}
        aria-label={open ? "بستن چت" : "چت آنلاین"}
        aria-expanded={open}
        onClick={toggleWidget}
      >
        {!open && <span className="floating-chat-pulse-ring" />}
        <Icon>{open ? CLOSE_ICON : CHAT_ICON}</Icon>
        {!open && totalUnread > 0 && (
          <span className="floating-chat-badge">
            {totalUnread > 99 ? "۹۹+" : totalUnread}
          </span>
        )}
      </button>

      {open && (
        <div className="chat-widget-panel" ref={panelRef}>
          {activeChatId == null ? (
            <>
              <div className="chat-widget-header">
                <span className="chat-widget-title">چت آنلاین</span>
                <button
                  type="button"
                  className="chat-widget-icon-btn"
                  onClick={() => setOpen(false)}
                  aria-label="بستن"
                >
                  <Icon>{CLOSE_ICON}</Icon>
                </button>
              </div>

              <div className="chat-widget-search">
                <Icon>{SEARCH_ICON}</Icon>
                <input
                  type="text"
                  placeholder="جستجوی فروشگاه یا مشتری..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>

              <div className="chat-widget-list">
                {loading && (
                  <div className="chat-widget-empty">در حال بارگذاری...</div>
                )}
                {!loading &&
                  chats.map((chat) => (
                    <button
                      type="button"
                      key={chat.id}
                      className={`chat-widget-row${chat.unread_count > 0 ? " has-unread" : ""}`}
                      onClick={() => openChat(chat.id)}
                    >
                      <span className="chat-widget-avatar-wrap">
                        <span className="chat-widget-avatar">
                          {initial(chat.customer_name)}
                        </span>
                        {chat.unread_count > 0 && (
                          <span className="chat-widget-unread-badge">
                            {chat.unread_count > 99 ? "۹۹+" : chat.unread_count}
                          </span>
                        )}
                      </span>
                      <span className="chat-widget-row-main">
                        <span className="chat-widget-row-name">
                          {chat.customer_name}
                        </span>
                        <span className="chat-widget-row-shop">
                          {chat.store_name}
                        </span>
                      </span>
                      <span className="chat-widget-row-time">
                        {formatTime(chat.last_message?.created_at)}
                      </span>
                    </button>
                  ))}
                {!loading && chats.length === 0 && (
                  <div className="chat-widget-empty">
                    چتی با این مشخصات پیدا نشد
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="chat-widget-header chat-widget-header--conv">
                <button
                  type="button"
                  className="chat-widget-icon-btn"
                  onClick={backToList}
                  aria-label="بازگشت به لیست"
                >
                  <Icon>{BACK_ICON}</Icon>
                </button>
                <span className="chat-widget-conv-avatar">
                  {initial(activeChat?.customer_name)}
                </span>
                <span className="chat-widget-conv-heading">
                  <span className="chat-widget-conv-name">
                    {activeChat?.customer_name}
                  </span>
                  <span className="chat-widget-conv-shop">
                    {activeChat?.store_name}
                  </span>
                </span>
                <button
                  type="button"
                  className="chat-widget-icon-btn"
                  onClick={() => setOpen(false)}
                  aria-label="بستن"
                >
                  <Icon>{CLOSE_ICON}</Icon>
                </button>
              </div>

              <div
                className="chat-widget-body"
                ref={bodyRef}
                style={CHAT_BODY_STYLE}
              >
                {messagesLoading ? (
                  <div className="chat-widget-empty">در حال بارگذاری...</div>
                ) : rows.length === 0 ? (
                  <div className="chat-widget-empty">پیامی وجود ندارد.</div>
                ) : (
                  rows.map((row) =>
                    row.type === "divider" ? (
                      <div key={row.key} className="chat-widget-date-divider">
                        <span>{row.label}</span>
                      </div>
                    ) : (
                      <div
                        key={row.key}
                        className={`chat-widget-bubble-row${row.data.sender_type !== "customer" ? " own" : ""}`}
                      >
                        <div className="chat-widget-bubble">
                          {row.data.body && (
                            <div className="chat-widget-bubble-text">
                              {row.data.body}
                            </div>
                          )}
                          {row.data.attachments?.length > 0 && (
                            <div className="chat-widget-attachments">
                              {row.data.attachments.map((a, idx) => (
                                <button
                                  key={a.id}
                                  type="button"
                                  className="chat-widget-attachment-item"
                                  onClick={() =>
                                    setPreviewGallery({
                                      images: row.data.attachments.map(
                                        (att) => ({
                                          image: attachmentUrl(att.image),
                                          name: attachmentName(att.image),
                                        }),
                                      ),
                                      index: idx,
                                    })
                                  }
                                >
                                  <img
                                    src={attachmentUrl(a.image)}
                                    alt={attachmentName(a.image)}
                                    className="chat-widget-attachment-img"
                                    loading="lazy"
                                  />
                                </button>
                              ))}
                            </div>
                          )}
                          <div className="chat-widget-bubble-time">
                            <span>{formatTime(row.data.created_at)}</span>
                            {row.data.sender_type !== "customer" && (
                              <SeenTicks seen={isMessageSeen(row.data)} />
                            )}
                          </div>
                        </div>
                      </div>
                    ),
                  )
                )}
              </div>

              {isAdmin ? (
                <div
                  className="chat-widget-composer"
                  style={{
                    textAlign: "center",
                    padding: "12px",
                    opacity: 0.7,
                    fontSize: "12px",
                  }}
                >
                  شما به‌عنوان ادمین فقط امکان مشاهده‌ی گفتگو را دارید.
                </div>
              ) : (
                <div className="chat-widget-composer">
                  {attachments.length > 0 && (
                    <div className="chat-widget-composer-attachments">
                      {attachments.map((file) => (
                        <div
                          key={file.id}
                          className="chat-widget-attachment-chip removable"
                        >
                          <span>{file.name}</span>
                          <button
                            type="button"
                            onClick={() => removeAttachment(file.id)}
                            aria-label="حذف پیوست"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="chat-widget-composer-row">
                    <button
                      type="button"
                      className="chat-widget-attach-btn"
                      onClick={() => fileInputRef.current?.click()}
                      title="پیوست فایل"
                    >
                      <Icon>{ATTACH_ICON}</Icon>
                    </button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      hidden
                      onChange={handleFileChange}
                    />
                    <textarea
                      className="chat-widget-input"
                      placeholder="پیام خود را بنویسید..."
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      onKeyDown={handleKeyDown}
                      rows={1}
                    />
                    <button
                      type="button"
                      className="chat-widget-send-btn"
                      onClick={send}
                      disabled={
                        sending || (!text.trim() && attachments.length === 0)
                      }
                    >
                      {sending ? "..." : "ارسال"}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {previewGallery && (
        <div
          className="chat-widget-preview-overlay"
          onClick={() => setPreviewGallery(null)}
        >
          <div
            className="chat-widget-preview-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="chat-widget-preview-close"
              onClick={() => setPreviewGallery(null)}
              aria-label="بستن"
            >
              ×
            </button>

            {previewGallery.images.length > 1 && (
              <button
                type="button"
                className="chat-widget-preview-nav prev"
                onClick={showPrevImage}
                aria-label="عکس قبلی"
              >
                <Icon>
                  <path d="M15 18l-6-6 6-6" />
                </Icon>
              </button>
            )}

            <img
              src={previewGallery.images[previewGallery.index].image}
              alt={previewGallery.images[previewGallery.index].name}
              className="chat-widget-preview-img"
            />

            {previewGallery.images.length > 1 && (
              <button
                type="button"
                className="chat-widget-preview-nav next"
                onClick={showNextImage}
                aria-label="عکس بعدی"
              >
                <Icon>
                  <path d="M9 18l6-6-6-6" />
                </Icon>
              </button>
            )}

            {previewGallery.images.length > 1 && (
              <div className="chat-widget-preview-counter">
                {previewGallery.index + 1} / {previewGallery.images.length}
              </div>
            )}

            {previewGallery.images[previewGallery.index].name && (
              <div className="chat-widget-preview-caption">
                {previewGallery.images[previewGallery.index].name}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
